import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  namespaced: true,
  state() {
    return {
      knownustypes: [],
      errorCall: [],
      perPage: 10,
    };
  },
  mutations,
  actions,
  getters
};
